import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function AddressIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 20" {...props}>
        <path d="M6.5 0A6.34 6.34 0 0 0 0 6.15a5.86 5.86 0 0 0 .86 3.07L6.5 20l5.65-10.81a5.84 5.84 0 0 0 .85-3A6.34 6.34 0 0 0 6.5 0m4.37 8.42v.08L6.5 16.76 2.19 8.52a.4.4 0 0 0 0-.08 4.4 4.4 0 0 1-.69-2.29 4.84 4.84 0 0 1 5-4.65 4.84 4.84 0 0 1 5 4.65 4.44 4.44 0 0 1-.63 2.27" />
        <path d="M6.5 4A2.5 2.5 0 1 0 9 6.5 2.5 2.5 0 0 0 6.5 4m0 3.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1" />
      </svg>
    </Icon>
  )
}
export default AddressIcon
